// StatusPill — rounded pill for status / result indicators
// Mirrors the pill component shown in the Figma WPS UI / PQR UI / WQTR UI mockups.
// Kinds: success | warning | info | danger | neutral
// CR-2026-WELDASSURE-UI-REFACTOR

import React from "react";
import { Box, Typography } from "@mui/material";

const PALETTE = {
  success: { bg: "#DCF2E5", fg: "#228B52" },
  warning: { bg: "#FDEDD5", fg: "#DC8C1E" },
  info:    { bg: "#DCEAFD", fg: "#2163C8" },
  danger:  { bg: "#FEE2E2", fg: "#B02020" },
  neutral: { bg: "#F5F7FA", fg: "#555F6B" },
};

export default function StatusPill({ label, kind = "neutral", size = "md", sx = {} }) {
  const pal = PALETTE[kind] || PALETTE.neutral;
  const dims = size === "sm"
    ? { px: 1, py: 0.25, fontSize: 10, height: 18 }
    : { px: 1.25, py: 0.5, fontSize: 11, height: 22 };
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        bgcolor: pal.bg,
        color: pal.fg,
        borderRadius: 9999,
        px: dims.px,
        height: dims.height,
        fontWeight: 600,
        fontSize: dims.fontSize,
        letterSpacing: 0.2,
        lineHeight: 1,
        whiteSpace: "nowrap",
        ...sx,
      }}
    >
      {label}
    </Box>
  );
}
